// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { CategoriesResponse } from '../models/category';

export const categoriesRequested = createAction('[CATEGORIES] Categories Requested', props<{ clientId: string }>());
export const categoriesRequestSucceeded = createAction('[CATEGORIES] Categories Request Succeeded', props<{
  categoriesResponse: CategoriesResponse
}>());
export const categoriesRequestFailed = createAction('[CATEGORIES] Categories Request Failed');
